module.exports = __webpack_public_path__ + "static/media/Monogram logo.07776b88.PNG";